export default __webpack_public_path__ + "static/contact-hero-image-10581f643c61d2617915b5afcc238db9.jpg";